import React from 'react';
import { Helmet } from "react-helmet";
//Components for hub
import TimelinePromo from 'components/Hub/TimelinePromo/TimelinePromo';
import Hero from 'components/Hub/Hero/Hero';
import VideoSection from 'components/Hub/VideoSection/VideoSection';
import FeaturedPromo from 'components/Hub/FeaturedPromo/FeaturedPromo';
import DynamicPagePromos from 'components/Hub/DynamicPagePromos/DynamicPagePromos';

//Shared components for hub
import Advert from 'components/Shared/Advert/Advert';
import Carrousel from 'components/Shared/Carousel/Carousel';
import RelatedContent from 'components/Shared/RelatedContent/RelatedContent';
import Footer from 'components/Shared/Footer/Footer'

//Data
import globalJson from 'data/content.json';
import articlesJson from 'data/articles'

//File gatherer
import { getFileList } from 'helpers/FileCaching';

const heroImages = require.context('../../assets/images/Hero', true, /.*\.(gif|png|jpe?g|svg)$/i);
var Preload = require('react-preload').Preload;

const Hub = ({history}) => {

    var loadingIndicator = (<div style={{color:"white", margin:"0 auto", textAlign:"center"}}><h1 >Made on Earth</h1><p style={{color:"white"}}>Loading...</p></div>);
    let heroImageNameList = getFileList(heroImages)

    //List all articles for snapshot
    const allArticleLinks = articlesJson.articles.map((article, index) => {
        return(
            <a key={index} href={article.url}></a>
        )
    })

    let carRef = React.createRef();

	return(
        <>
            <Helmet>
				<title>{ globalJson.meta.title }</title>
				<meta name="description" content={globalJson.meta.pageDescription} />
				<meta property="fb:app_id" content={globalJson.social.fb_app_id} />
		    </Helmet>

            {allArticleLinks}
            
            <Preload
            loadingIndicator={loadingIndicator}
            images={heroImageNameList}
            >
              
                <div>

                    <div className={`header_bg`}>
                        <Hero />
                    </div>

                    <FeaturedPromo history={history} />
                    <Advert content={globalJson.advertisingOne} />
                    <DynamicPagePromos content={globalJson.dynamicPromos.promos} history={history} carRef={carRef}/>
                    <Carrousel />
                    <VideoSection content={globalJson.videoSection}></VideoSection>
                    <TimelinePromo />
                    <Advert content={globalJson.advertisingTwo} />
                    <RelatedContent content={globalJson.relatedContent.content}/>
                    <Footer />

                </div>
            </Preload>

        </>
	)

}

export default Hub;